/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Support_TitleInputs */

const en_common_support_title = /** @type {(inputs: Common_Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Support`)
};

const zh_common_support_title = /** @type {(inputs: Common_Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系客服`)
};

/**
* | output |
* | --- |
* | "Contact Support" |
*
* @param {Common_Support_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_support_title = /** @type {((inputs?: Common_Support_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Support_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_support_title(inputs)
	return zh_common_support_title(inputs)
});
export { common_support_title as "common.support.title" }